<template>
    <form-accordion
        name="contact-information"
        section="Contact Information"
        :url="url"
        method="patch"
        :closed="closed"
        :collapsible="accordion"
        :include_discard_button="include_discard_button"
        @saved="handleFormSaved"
    >
        <broker-name
            :broker="broker"
        />

        <broker-email
            :broker="broker"
            :read_only="! email_editable"
        />

        <broker-phone
            :show-team-message-consent="showTeamMessageConsent"
            v-if="is_broker"
            :settings="settings"
            :broker="broker"
        />

        <broker-whatsapp
            :show-team-message-consent="showTeamMessageConsent"
            :community-enabled="!!(tenant && tenant.has_whats_app_community)"
            ref="brokerWhatsapp"
            :broker="broker"
            :previous-whats-app-number="previousWhatsAppNumber"
            @community-response="handleWhatsAppCommunityResponse"
        />

        <account-user-role
            v-if="is_broker"
            :role="account_user_role"
            @change="roleChanged"
        />

        <office-information
            v-if="is_broker && role === 'agent_or_broker'"
            :settings="settings"
        />

        <broker-mls
            v-if="is_broker && role === 'agent_or_broker'"
            :settings="settings"
        />
    </form-accordion>
</template>

<script>
import BrokerName from './broker-name.vue';
import BrokerEmail from './broker-email.vue';
import BrokerPhone from './broker-phone.vue';
import BrokerWhatsapp from './broker-whatsapp.vue';
import AccountUserRole from './account-user-role.vue';
import BrokerMls from './broker-mls.vue';
import OfficeInformation from './office-information.vue';

export default {
    components: {
        BrokerName,
        BrokerEmail,
        BrokerPhone,
        BrokerWhatsapp,
        AccountUserRole,
        BrokerMls,
        OfficeInformation,
    },

    props: {
        showTeamMessageConsent: { type: Boolean, default: false },
        closed: { default: true },
        url: {},
        broker: {},
        settings: {},
        accordion: { default: true },
        include_discard_button: { default: true },
        email_editable: { default: true },
        account_user_role: {},
        tenant: {},
        is_broker: { default: true },
    },

    data() {
        return {
            role: this.account_user_role,
            previousWhatsAppNumber: this.broker.whats_app_number || null,
        }
    },

    methods: {
        roleChanged(role) {
            this.role = role;
            this.$emit('roleChanged', role);
        },
        handleWhatsAppCommunityResponse(accepted) {
            // Save the community status immediately when modal response is received
            if (this.tenant && this.tenant.has_whats_app_community) {
                if (! this.broker.name) {
                    console.error('Name is missing! Cannot submit WhatsApp community status.');
                    return;
                }

                // Get whats_app_number from broker-whatsapp component's local state if broker doesn't have it
                const whatsAppNumber = this.broker.whats_app_number || 
                    (this.$refs.brokerWhatsapp && this.$refs.brokerWhatsapp.whatsAppNumber) || 
                    null;

                axios.patch(this.url, {
                    name: this.broker.name,
                    email: this.broker.email,
                    account_user_role: this.broker.account_user_role,
                    whats_app_number: whatsAppNumber,
                    in_whats_app_community: accepted,
                })
                    .then(response => {
                        if (response.data) {
                            Object.assign(this.broker, response.data);
                            // Force reactivity update for in_whats_app_community
                            this.$set(this.broker, 'in_whats_app_community', response.data.in_whats_app_community || false);
                        }
                    })
                    .catch(error => {
                        if (error.response && error.response.data) {
                            if (error.response.data.errors) {
                                console.error('Validation errors (full object):', JSON.stringify(error.response.data.errors, null, 2));
                            }
                            if (error.response.data.message) {
                                console.error('Error message:', error.response.data.message);
                            }
                        }
                    });
            }
        },
        handleFormSaved(brokerData) {
            // Check if WhatsApp number was added after form save
            // brokerData is the broker object from response.data (emitted by form-submit)
            if (!brokerData) return;
            Object.assign(this.broker, brokerData);
            if (!this.tenant || !this.tenant.has_whats_app_community || !this.$refs.brokerWhatsapp) return;

            const newWhatsAppNumber = brokerData?.whats_app_number || null;
            this.$refs.brokerWhatsapp.checkAndShowModal(newWhatsAppNumber);
            this.previousWhatsAppNumber = newWhatsAppNumber;
        },
    },
}
</script>
